<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="16" width="18"><!--!Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path class="fa-secondary" opacity=".4" d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"/><path class="fa-primary" d=""/></svg>
</template>
<script setup lang="ts">
</script>
